import { customAxios, IDUSUARIO, FDV_URL, PROFORMA_URL,USERNAME } from '../constants';
import { FETCH_PROFORMAS, FETCH_PROFORMA, CLEAR_PROFORMAS, SEARCH_PROFORMAS, CLEAR_PROFORMAS_BUSCAR } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchProformas(fdvID, proformaID = null) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      numProfVeh: proformaID,
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/proformas`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PROFORMAS,
    payload: request,
  };
}

export function fetchProforma(fdvID, proformaID) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/proformas/${proformaID}`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PROFORMA,
    payload: request,
  };
}

export function clearProformas() {
  return {
    type: CLEAR_PROFORMAS,
  };
}

export function searchProformas(cliente, nroProforma, areaVenta, compania, vendedor, numPag = '1') {
  const data = {
    nroProforma,
    areaVenta,
    cliente,
    compania,
    vendedor,
    sinFichaVenta: 'S',
    estados: ['A'],
  };

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      numPag,
      cantiRegPag: '10',
    },
  };

  const request = customAxios.post(`${PROFORMA_URL}/consulta/listar`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SEARCH_PROFORMAS,
    payload: request,
  };
}
//Inicio Req. 86268 - Soporte legados- función que consume servicio de impresion de proforma y estado de precios
export function imprimirProforma(nroProforma) {

  const data = {
    codSeccion:'',
    codTipoUso:'',
    indVistaPrevia:'',
    nroProforma
  };

 
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
      numPag :1
    }
    
  };

  const request = customAxios.post(`${PROFORMA_URL}/proforma/imprimir/pdf`,data,config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: 'IMPRIMIR_PROFORMA',
    payload: request,
  };
}

export function imprimirEstadoPrecios(nroProforma) {

  const data = {
    codSeccion:'',
    codTipoUso:'',
    nroProforma
  };

 
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
      numPag :1
    }
    
  };

  const request = customAxios.post(`${PROFORMA_URL}/proforma/imprimir/estructuraPrecios`,data,config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: 'IMPRIMIR_ESTPRECIOS',
    payload: request,
  };
}
//InicioReq. 86268 - Soporte legados- función que consume servicio de impresion de proforma y estado de precios

export function clearProformasBuscar() {
  return {
    type: CLEAR_PROFORMAS_BUSCAR,
  };
}

//Inicio Req - 90917_L_Absorcion_Legados_Fase_2
export function obtenerProformaCliente(nroProforma, numPag = '1') {
  const data = {
    nroProforma 
  };

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      numPag,
      cantiRegPag: '10',
    },
  };

  const request = customAxios.post(`${PROFORMA_URL}/consulta/obtenerProformaCliente`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SEARCH_PROFORMAS,
    payload: request,
  };
}
//Fin Req - 90917_L_Absorcion_Legados_Fase_2


// WEBPACK FOOTER //
// ./src/actions/Proformas.js